/**
 * SHA-256 checksum of a File/Blob, hex-encoded.
 *
 * Bronco's CSV import endpoints (`/listings/import`, `/accounts/import`) require the client
 * to send this alongside the upload so the server can verify the bytes it received match the
 * bytes the browser read.
 *
 * @param {File|Blob} file
 * @returns {Promise<string>} hex-encoded SHA-256 digest
 */
const generateChecksum = async (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = async (e) => {
			try {
				const fileContent = e.target.result;
				const buffer = new Uint8Array(fileContent);
				const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
				const hashArray = Array.from(new Uint8Array(hashBuffer));
				const checksum = hashArray
					.map((item) => {
						return item.toString(16).padStart(2, '0');
					})
					.join('');
				resolve(checksum);
			} catch (error) {
				reject(error);
			}
		};
		reader.onerror = (error) => {
			reject(error.target.error);
		};
		reader.readAsArrayBuffer(file);
	});
};

export {
	generateChecksum,
};
